export default __webpack_public_path__ + "static/media/Thug's Tunic of the Grim Cabal.0df76fc3.jpg";